import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class EmptyInvoiceListItem extends PureComponent {

    static propTypes = {
        item: PropTypes.object.isRequired,
        index: PropTypes.number,
    };

    render() {
        const {
            index,
            item,
        } = this.props;

        return (            
            <tr className="table-list-row">
                <td className="table-list-col" style={{width: '60px'}}>
                    {index}.
                </td>
                <td className="table-list-col">
                    {item.invoicenumber}
                </td>
                <td className="table-list-col">
                    {item.yearmonth}
                </td>
                <td className="table-list-col">
                    {item.istarttag}
                </td>
            </tr>
        );
    }
}

export default EmptyInvoiceListItem;



// WEBPACK FOOTER //
// ./src/components/emptyInvoice/EmptyInvoiceListItem.jsx